import { LoadingButton } from '@mui/lab';
import { ReactNode } from 'react';

interface Props {
  loading: boolean;
  disabled: boolean;
  children: ReactNode;
}

/** Shared submit button for all login forms — eliminates repeated Button+CircularProgress boilerplate. */
export const SubmitButton = ({ loading, disabled, children }: Props) => (
  <LoadingButton
    type="submit"
    variant="contained"
    size="large"
    fullWidth
    loading={loading}
    disabled={disabled}
    sx={{ height: '3rem' }}
  >
    {children}
  </LoadingButton>
);
